<template>
  <color-picker
    :wheel-lightness="false"
    :handle-radius="20"
    v-model="color"
    class="d-flex justify-content-center"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import hexToRGB from '@/utils/color';
import ColorPicker from '@/components/inputs/ColorPicker.vue';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import RGBMixin from '@/components/utils/mixins/RGB';

export default {
  name: 'RGBPicker',
  mixins: [
    BaseControlMixin,
    RGBMixin,
  ],
  data() {
    return {
      defaultColor: '#ffffff',
      color: this.getColor(),
    };
  },
  computed: {
    ...mapGetters([
      'getActorVars',
    ]),
  },
  components: {
    ColorPicker,
  },
  methods: {
    ...mapActions([
      'setVarsValue',
    ]),
    getColor() {
      let color = '#ffffff';
      if (this.vars && this.vars.length === 3) {
        color = this.RGB2Hex(this.vars);
      }
      if (color === '#000000') { // color picker cant handle black color
        return this.defaultColor;
      }
      return color;
    },
    colorSelected(value) {
      const rgbArr = hexToRGB(value);
      this.vars.forEach((varItem, index) => {
        this.setVarsValue({ varItem, value: rgbArr[index] });
      });
    },
  },
  watch: {
    color(newValue) {
      this.colorSelected(newValue);
    },
  },
};
</script>

<style scoped>

</style>
